require('select2/dist/js/select2.full');
require('select2/dist/js/i18n/fr');

require('select2/dist/css/select2.css');
require('./select2-bootstrap.css');
require('./select2-bootstrap.4.css');